import { classNames } from "@opensea/ui-kit"

export const CREATE_COLLECTION_OFFER_FLOW_TABLE_CLASSNAMES = {
  collection: classNames("grow first:pl-0"),
  floor: classNames("hidden w-[120px] justify-end md:flex"),
  traitFloor: classNames("hidden w-[120px] justify-end md:flex"),
  bestOffer: classNames("hidden w-[130px] justify-end md:flex"),
  traitBestOffer: classNames("hidden w-[120px] justify-end md:flex"),
  proceeds: classNames("hidden w-[120px] justify-end md:flex"),
  price: classNames("w-[150px] justify-end last:pr-0"),
}
